import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { FG_MERCHANT_ROUTE_PATHS } from './config';

export const FULL_GATEWAY_MERCHANT_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-full-gateway-merchant',
    path: FG_MERCHANT_ROUTE_PATHS.fullGatewayMerchant,
    component: lazy(() => import('./pages/full-gateway-merchant-page')),
    layout: 'default',
    permissions: { scopes: ['movements-full-gateway-merchant'] },
    menu: {
      title: 'Full Gateway Merchant',
    },
  },
];